import YFormTitle from './Title';

export { YFormTitle };
export default YFormTitle;
